import React from "react";

const Domoelec = () => {
  const commitmentItems = [
    {
      icon: 'fas fa-shield-alt',
      title: 'Sécurité',
      desc: 'Installations conformes aux normes les plus strictes du marché.'
    },
    {
      icon: 'fas fa-award',
      title: 'Expertise',
      desc: "+13 ans d'expérience avec des équipes certifiées."
    },
    {
      icon: 'fas fa-tools',
      title: 'Maintenance',
      desc: 'Service préventif et correctif pour garantir la continuité.'
    },
    {
      icon: 'fas fa-handshake',
      title: 'Accompagnement',
      desc: 'Un interlocuteur dédié du conseil à la mise en service.'
    },
    {
      icon: 'fas fa-bolt',
      title: 'Réactivité',
      desc: "Intervention d'urgence sous 24h sur tout le territoire."
    },
    {
      icon: 'far fa-lightbulb',
      title: 'Innovation',
      desc: 'Solutions connectées et intelligentes pour vos bâtiments.'
    }
  ];

  return (
    <div className="domo-page">
      <section className="domo-intro">
        <div className="container">
          <div className="domo-intro-grid">
            <div className="domo-intro-left">
              <span className="domo-label">À propos</span>
              <h1>
                Qui sommes-<span className="hdr-green">nous</span> ?
              </h1>
              <p>
                DOMOELEC est une entreprise marocaine spécialisée dans les solutions de
                courants faibles et de sécurité électronique.
              </p>
              <p>
                Nous intervenons dans les domaines de la détection incendie, de la mise
                en sécurité, de l’éclairage de sécurité, de la vidéosurveillance, du
                contrôle d’accès, de la détection de gaz, de l&apos;extinction à gaz, de
                la domotique.
              </p>
              <p>
                Notre activité couvre principalement l’étude et le dimensionnement des
                systèmes, la fourniture des équipements, la programmation, la mise en
                service, l’assistance technique, le conseil et la maintenance.
              </p>
              <p>
                Nous collaborons avec des fabricants et partenaires reconnus afin de
                proposer des équipements adaptés aux besoins de chaque projet et
                conformes aux exigences techniques et réglementaires applicables.
              </p>
              <p>
                Présente sur différents types de projets à travers le Maroc, DOMOELEC
                travaille aux côtés des installateurs, bureaux d’études, entreprises et
                maîtres d’ouvrage pour assurer la bonne réalisation et le bon
                fonctionnement des solutions proposées.
              </p>
              <div className="domo-intro-cards">
                <div className="domo-intro-card">
                  <div className="domo-intro-card__icon">
                    <i className="fas fa-shield-alt"></i>
                  </div>
                  <h3>Qualité</h3>
                  <p>Des solutions fiables et durables</p>
                </div>
                <div className="domo-intro-card">
                  <div className="domo-intro-card__icon">
                    <i className="fas fa-lock"></i>
                  </div>
                  <h3>Sécurité</h3>
                  <p>Des installations conformes et sûres</p>
                </div>
                <div className="domo-intro-card">
                  <div className="domo-intro-card__icon">
                    <i className="fas fa-signal"></i>
                  </div>
                  <h3>Performance</h3>
                  <p>Des systèmes performants</p>
                </div>
              </div>
            </div>
            <div className="domo-intro-right">
              <img src="/images/Imagedomoelecfinale.jpg" alt="DOMOELEC" />
            </div>
          </div>
        </div>
      </section>

      <section className="domo-engagement">
        <div className="container">
          <div className="domo-engagement-card">
            <div className="domo-engagement-director">
              <div className="domo-engagement-director__avatar">
                <i className="fas fa-user-tie"></i>
              </div>
            </div>
            <div className="domo-engagement-copy">
              <div className="domo-engagement-heading">
                <span className="domo-label">Mot du directeur</span>
                <h3>Tarik El Bourzgui</h3>
                <span className="domo-engagement-role">Directeur Général – DOMOELEC</span>
              </div>
              <div className="domo-engagement-quote">
                <i className="fas fa-quote-left"></i>
                <h2>
                  Chez DOMOELEC, nous plaçons l’expertise technique, la qualité de service
                  et la confiance au cœur de chacune de nos collaborations.
                </h2>
              </div>
              <p>
                Notre engagement est d’apporter à nos clients des solutions fiables,
                adaptées et conformes à leurs besoins, tout en les accompagnant avec
                rigueur, réactivité et professionnalisme à chaque étape de leurs projets.
                Grâce à une équipe engagée et à des partenaires de confiance, nous
                poursuivons notre développement avec une ambition constante : construire
                des relations durables et contribuer à la réussite des projets qui nous
                sont confiés.
              </p>
              <p>
                Nous remercions sincèrement nos clients, partenaires et collaborateurs
                pour leur confiance.
              </p>
              <p>
                <strong>Tarik El Bourzgui</strong>
                <br />
                Directeur Général – DOMOELEC
              </p>
            </div>
            <div className="domo-engagement-visual" aria-hidden="true">
              <div className="domo-engagement-visual__shield">
                <i className="fas fa-shield-alt"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="domo-values">
        <div className="container">
          <div className="domo-values-header">
            <span className="domo-label">Nos engagements</span>
            <h2>Pourquoi choisir <span className="hdr-green">DOMOELEC</span> ?</h2>
            <span className="domo-values-divider" aria-hidden="true"></span>
          </div>
          <div className="domo-commitments-line">
            {commitmentItems.slice(0, 5).map((item, index) => (
              <div className="domo-commitment" key={item.title}>
                <div className="domo-commitment__node">
                  <div className="domo-commitment__icon">
                    <i className={item.icon}></i>
                  </div>
                  {index < 4 && <span className="domo-commitment__connector" aria-hidden="true"></span>}
                </div>
                <div className="domo-commitment__content">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="domo-commitment domo-commitment--center">
            <div className="domo-commitment__node">
              <div className="domo-commitment__icon">
                <i className={commitmentItems[5].icon}></i>
              </div>
            </div>
            <div className="domo-commitment__content">
              <h3>{commitmentItems[5].title}</h3>
              <p>{commitmentItems[5].desc}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Domoelec;
